import api from "api/api";

export const searchPersonsByProfile = async ({
  profile,
  search,
  userScope,
}) => {
  if (search.length > 2)
    return await api.get(
      `/directory/search/person?${
        profile ? `profile=${profile}&search=${search}` : `search=${search}`
      }&scope=${userScope}`
    );
  return [];
};

export const getPersonsByIdsQuery = async ({ ids, userScope }) =>
  await api.get(`directory/person/ids/${ids}?scope=${userScope}`);

export const getPersonByIdQuery = async (id, userScope) =>
  await api.get(`directory/person/${id}?scope=${userScope}`);

export const getPersonBySlugQuery = async (slug, userScope) =>
  await api.get(`directory/person/slug/${slug}?scope=${userScope}`);

export const isManagerOfPersonQuery = async (personId, managerId) =>
  await api.get(
    `directory/person/is-manager?manager_id=${managerId}&person_id=${personId}`
  );

export const getHierarchyEmailAddressesQuery = async ({
  userScope,
  entities,
}) => {
  const entitiesParams = new URLSearchParams();
  entities.forEach((entity) => entitiesParams.append("entity", entity));
  return await api.get(
    `directory/person/hierarchy/emails?scope=${userScope}&${entitiesParams}`
  );
};
